import type { ColumnDef } from '@tanstack/react-table';

import type { GetPollsQuery } from 'data/__generated__';
import { textColumn, dateColumn, numberColumn } from 'components/DataTable';

export type PollRow = GetPollsQuery['polls']['polls'][number];

export const pollsColumns: ColumnDef<PollRow, unknown>[] = [
    dateColumn<PollRow, Record<string, unknown>>({
        accessorKey: 'createdAt',
        header: 'Date de création',
        filterKey: 'createdAt',
        defaultVisible: true,
    }),
    textColumn<PollRow, Record<string, unknown>>({
        accessorKey: 'question',
        header: 'Question',
        filterKey: 'question',
        defaultVisible: true,
    }),
    numberColumn<PollRow, Record<string, unknown>>({
        accessorKey: 'numberOfParticipants',
        header: 'Participations',
        filterKey: 'numberOfParticipants',
        defaultVisible: true,
    }),
];
